import { render } from "./microServiceProduct.vue?vue&type=template&id=53164c6a&ts=true"
import script from "./microServiceProduct.vue?vue&type=script&lang=ts"
export * from "./microServiceProduct.vue?vue&type=script&lang=ts"

import "./microServiceProduct.vue?vue&type=style&index=0&id=53164c6a&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__